import { c as _c } from "react/compiler-runtime";
import { useXgSeatRequirement } from "@hooks/use-xg-seat-requirement";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { isMissingXgSeat } from "@utils/invite-xg-seat-utils";
import { doesWorkspaceRoleRequireXgSeat } from "@utils/xg-seat-utils";

/**
 * Returns whether a member has to be given a Sphere XG seat before they can take on a workspace
 * role.
 *
 * That is the case on a plan that requires a seat for the roles that need one, see
 * useXgSeatRequirement, the same as for the bulk role change, for a role that needs a seat and a
 * member that does not hold the assigned seat yet. While the plan is not known, the seat is asked
 * for as well. Teams cannot hold a seat, and without the member there is nothing to check, so their
 * roles change as before.
 *
 * @param member The member whose role is changed, if known
 */
export function useIsXgSeatRequiredForRole(member) {
  const $ = _c(3);
  const xgSeatRequirement = useXgSeatRequirement();
  let t0;
  if ($[0] !== member || $[1] !== xgSeatRequirement) {
    t0 = role => {
      if (!member || xgSeatRequirement === "notRequired" || FaroCoreApiUtils.Member.isTeam(member) || !doesWorkspaceRoleRequireXgSeat(role)) {
        return false;
      }
      return isMissingXgSeat(member);
    };
    $[0] = member;
    $[1] = xgSeatRequirement;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}